var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBootstrap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 150,
    viewBox: "0 0 151 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 51.032,
    y: 47.4304,
    width: 48.936,
    height: 55.1392,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2703 35.1696C40.5645 35.1696 36.3424 40.1637 36.5314 45.5797C36.7129 50.783 36.4771 57.5221 34.7807 63.0178C33.0781 68.5289 30.2008 72.0213 25.5 72.4696V77.5305C30.2008 77.9797 33.0781 81.4703 34.7805 86.9823C36.4771 92.478 36.7127 99.217 36.5312 104.42C36.3422 109.836 40.5643 114.83 46.2711 114.83H104.737C110.443 114.83 114.664 109.836 114.475 104.42C114.294 99.217 114.53 92.478 116.226 86.9823C117.929 81.4703 120.799 77.9783 125.5 77.5305V72.4696C120.799 72.0203 117.929 68.5297 116.226 63.0178C114.529 57.5229 114.294 50.783 114.475 45.5797C114.664 40.1645 110.443 35.1696 104.737 35.1696H46.2695H46.2703ZM93.2967 84.2061C93.2967 91.6637 87.734 96.1866 78.5025 96.1866H62.7881C62.3386 96.1866 61.9075 96.008 61.5896 95.6901C61.2717 95.3723 61.0932 94.9411 61.0932 94.4916V55.5086C61.0932 55.0591 61.2717 54.628 61.5896 54.3101C61.9075 53.9923 62.3386 53.8137 62.7881 53.8137H78.4131C86.1105 53.8137 91.1623 57.9832 91.1623 64.3848C91.1623 68.878 87.7639 72.9004 83.4344 73.6051V73.8395C89.3281 74.486 93.2967 78.568 93.2967 84.2061V84.2061ZM76.7891 59.1865H67.8289V71.8428H75.3756C81.2096 71.8428 84.4264 69.4936 84.4264 65.2946C84.4258 61.3594 81.6602 59.1865 76.7891 59.1865ZM67.8289 76.8645V90.8119H77.1187C83.193 90.8119 86.4104 88.3746 86.4104 83.7942C86.4104 79.2137 83.1027 76.8637 76.7281 76.8637H67.8289V76.8645Z",
    fill: "#7952B3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootstrap);
export default __webpack_public_path__ + "static/media/Bootstrap.1324e14f67290a51ed08cf5b7e15c037.svg";
export { ForwardRef as ReactComponent };